import request from '@/api/request'

export default {
  async getSizes () {
    return (await request.get(`module/action/marketplace/maisCorreios/size`)).data
  },
  async getCategories () {
    return (await request.get(`module/action/marketplace/maisCorreios/category/retrieve`)).data
  },
  async getCategoryAttributes (categoryId) {
    return (await request.get(`module/action/marketplace/maisCorreios/category/attributes/` + categoryId)).data
  },
  async getBrands () {
    return (await request.get(`module/action/marketplace/maisCorreios/brand/retrieve`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/maisCorreios/index.js